import { CapoPlugin } from "/home/runner/work/trueblue-web/trueblue-web/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];